import axios from "axios";
import {apiHost} from "../pages/common/Global";
import { store } from '../redux/store';
import { accountActions } from '../redux/actions/account';

// axios 인스턴스 생성
const instance = axios.create({
    baseURL: apiHost,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: true
});

// 요청 인터셉터
instance.interceptors.request.use(
    (config) => {
        // OPTIONS 요청인 경우 세션 ID를 추가하지 않음
        if (config.method === 'options') {
            return config;
        }

        // 로그인 API 호출 시에는 세션 ID를 포함하지 않음
        const isLoginRequest = config.url && (
            config.url.includes('/aLoginSession') || 
            config.url.includes('/login')
        );
        
        if (isLoginRequest) {
            return config;
        }

        try {
            const state = store.getState();
            const sessionId = state?.account?.sessionId;

            if (sessionId) {
                config.headers['X-Session-Id'] = sessionId;
            }
        } catch (error) {
            console.error('Error getting sessionId from store:', error);
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 응답 인터셉터 - 401 에러 처리
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // 세션 만료 처리
            try {
                // 세션 정보 초기화
                store.dispatch(accountActions.initAccount());
                
                // alert 표시
                window.alert('세션이 만료되었습니다. 다시 로그인해주세요.');
                
                // HashRouter를 사용하므로 경로 앞에 # 추가
                window.location.href = '/#/login';
            } catch (err) {
                console.error('Error handling 401 response:', err);
                window.location.href = '/#/login';
            }
        }
        return Promise.reject(error);
    }
);

function post(request, body) {
    return instance.post(request, body);
}

function get(request, body) {
    return instance.get(request, {
        params: body,
    })
}

export function put(request, body) {
    return instance.put(request, body);
}

export function deleteM(request, body) {
    return instance.delete(request, body);
}

export function login(params) {
    const request = apiHost + "/api/v1/admin/aLoginSession";
    return post(request, params);
}

// export function login(params) {
//     const request = apiHost + "/api/v1/admin/aLogin";
//     return post(request, params);
// }

export function getGUserPartnerList() {
    const request = apiHost + "/api/v1/partner/list";
    return get(request);
}

export function getGUser(userId) {
    const request = apiHost + "/api/v1/admin/user/" + userId;
    return get(request);
}

export function getGUserWithGameBalance(companyCode, userId) {
    const request = apiHost + "/api/v1/admin/user/" + companyCode + "/" + userId + "/with-game-balance";
    return get(request);
}

export function getGUserList(params) {
    const request = apiHost + "/api/v1/admin/user/list";
    return post(request, params);
}

export function getPartnerTreeList(params) {
    const request = apiHost + "/api/v1/admin/user/partner/tree";
    return post(request, params);
}

export function getGUserListByUserType(userType) {
    const request = apiHost + "/api/v1/admin/user/userType/" + userType;
    return get(request);
}

export function getGUserListByAccept(companyCode) {
    const request = apiHost + "/api/v1/admin/user/accept/" + companyCode + "/list";
    return get(request);
}

export function getLoginUserList(params) {
    const request = apiHost + "/api/v1/admin/user/login/list"
    return post(request, params);
}

export function putGUser(gUser) {
    const request = apiHost + "/api/v1/admin/user/";
    return put(request, gUser);
}

export function bulkCreateUsers(params) {
    const request = apiHost + "/api/v1/admin/user/bulk";
    return post(request, params);
}

export function putDeposit(deposit) {
    const request = apiHost + "/api/v1/admin/user/cash/deposit";
    return put(request, deposit)
}

export function cancelDeposit(deposit) {
    const request = apiHost + "/api/v1/admin/user/cash/deposit/cancel";
    return put(request, deposit)
}

export function getRequestDepositList(params) {
    const request = apiHost + "/api/v1/admin/user/cash/deposit/request/list";
    return post(request, params);
}

export function getDepositList(params) {
    const request = apiHost + "/api/v1/admin/user/cash/deposit/list";
    return post(request, params);
}

export function getUserCashByAdmin(params) {
    const request = apiHost + "/api/v1/admin/user/cash/admin/list";
    return post(request, params);
}

export function getUserPointByAdmin(params) {
    const request = apiHost + "/api/v1/admin/user/point/admin/list";
    return post(request, params);
}

export function putWithdraw(withdraw) {
    const request = apiHost + "/api/v1/admin/user/cash/withdraw"
    return put(request, withdraw)
}

export function getRequestWithdrawList(params) {
    const request = apiHost + "/api/v1/admin/user/cash/withdraw/request/list"
    return post(request, params)
}

export function getWithdrawList(params) {
    const request = apiHost + "/api/v1/admin/user/cash/withdraw/list"
    return post(request, params)
}

export function getDashboard(params) {
    const request = apiHost + "/api/v1/admin/dashboard/summary"
    return post(request, params)
}

export function getHeader(params) {
    const request = apiHost + "/api/v1/admin/dashboard"
    return post(request, params)
}

// 게시판
export function getBoardList(params) {
    const request = apiHost + "/api/v1/admin/board/list"
    return post(request, params)
}

export function postBoard(notice) {
    const request = apiHost + "/api/v1/admin/board/post"
    return put(request, notice)
}

export function postBoardReply(articleId, params) {
    const request = apiHost + "/api/v1/admin/board/" + articleId + "/reply";
    return post(request, params)
}

// 설정
export function getSiteSetting(params) {
    const request = apiHost + "/api/v1/admin/setting"
    return post(request, params)
}

// 사이트 옵션 저장
export function putSiteServiceOptionList(params) {
    const request = apiHost + "/api/v1/admin/setting/service/options"
    return put(request, params)
}

// 메신저 설정 저장
export function putMessengerList(params) {
    const request = apiHost + "/api/v1/admin/setting/messenger"
    return put(request, params)
}

export function getSiteConfig(siteId) {
    const request = apiHost + "/api/v1/admin/config/site/" + siteId
    return get(request)
}

export function putSiteConfig(config) {
    const request = apiHost + "/api/v1/admin/config/site"
    return put(request, config)
}

export function getSiteConfigUserLevel(siteId, userLevel) {
    const request = apiHost + "/api/v1/admin/config/site/" + siteId + "/" + userLevel
    return get(request)
}

export function putSiteConfigUserLevel(siteLevelConfig) {
    const request = apiHost + "/api/v1/admin/config/site/level"
    return put(request, siteLevelConfig)
}

// 점검 설정
export function getSiteInspection(siteId) {
    const request = apiHost + "/api/v1/admin/config/site/inspection/" + siteId
    return get(request)
}

export function putSiteInspection(inspect) {
    const request = apiHost + "/api/v1/admin/config/site/inspection"
    return put(request, inspect)
}

// 경기 종목 조회
export function getSportsBaseList() {
    const request = apiHost + "/api/v1/admin/sports/base/list";
    return get(request)
}

// 사용자별 경기 설정
export function putSportsSetting(setting) {
    const request = apiHost + "/api/v1/admin/user/sports/setting"
    return put(request, setting)
}

// 사용자별 요율 설정
export function putSportsPer(sportsPer) {
    const request = apiHost + "/api/v1/admin/user/sports/per"
    return put(request, sportsPer);
}

// 보유금 처리
export function postMoney(money) {
    const request = apiHost + "/api/v1/admin/cash/post"
    return post(request, money)
}

export function postPoint(point) {
    const request = apiHost + "/api/v1/admin/point/post"
    return post(request, point)
}

// 로그인 이력
export function loginHistory(params) {
    const request = apiHost + "/api/v1/login/history"
    return post(request, params)
}

// 베팅이력
export function getBettingList(params) {
    const request = apiHost + "/api/v1/admin/betting/list"
    return post(request, params)
}

export function getMinigameBettingList(params) {
    const request = apiHost + "/api/v1/admin/betting/minigame/list"
    return post(request, params)
}

export function getCasinoBettingList(params) {
    const request = apiHost + "/api/v1/admin/betting/casino/list/paged"
    return post(request, params)
}

export function getSlotBettingList(params) {
    const request = apiHost + "/api/v1/admin/betting/slot/list/paged"
    return post(request, params)
}

export function putSportScore(score) {
    const request = apiHost + "/api/v1/admin/sports/score"
    return put(request, score)
}

export function getBettingDetailList(bettingId) {
    const request = apiHost + "/api/v1/admin/betting/detail/" + bettingId
    return get(request)
}

/**
 * 통계 정보
 */
export function getUserStatistics(params) {
    const request = apiHost + "/api/v1/admin/report/user/statistics"
    return post(request, params)
}

export function getGameStatistics(params) {
    const request = apiHost + "/api/v1/admin/report/game/statistics"
    return post(request, params)
}

export function getDailyStatistics(params) {
    const request = apiHost + "/api/v1/admin/report/daily/statistics"
    return post(request, params)
}

/**
 * 포인트 이력
 */
export function getUserPointList(params) {
    const request = apiHost + "/api/v1/admin/user/point/list"
    return post(request, params)
}

/**
 * 머니이력
 */
export function getUserCashList(params) {
    const request = apiHost + "/api/v1/admin/cash/list"
    return post(request, params)
}

/**
 * 회원 롤링정보
 */
export function putUserRolling(params) {
    const request = apiHost + "/api/v1/admin/user/rolling"
    return put(request, params)
}

/**
 * 스포츠 설정 조회
 */
export function getSportsConfig(params) {
    const request = apiHost + "/api/v1/admin/sports/config/list"
    return post(request, params)
}

export function getCompanyBaseSetting(companyCode) {
    const request = apiHost + "/api/v1/admin/sports/setting/" + companyCode
    return get(request)
}

export function putCompanyBaseSetting(setting) {
    const request = apiHost + "/api/v1/admin/sports/setting/base"
    return put(request, setting)
}

export function putCompanySportJoint(joint) {
    const request = apiHost + "/api/v1/admin/sports/setting/joint"
    return put(request, joint)
}

// 미니게임
export function getDhPowerballOdds(companyCode, minigame) {
    const request = apiHost + "/api/v1/admin/minigame/" + companyCode + "/" + minigame + "/hole/odd/list"
    return get(request)
}

export function getDhPowerballResultList(params) {
    const request = apiHost + "/api/v1/admin/minigame/powerball/results"
    return post(request, params);
}

export function getDhPowerLadderResultList(params) {
    const request = apiHost + "/api/v1/admin/minigame/powerladder/results"
    return post(request, params);
}

export function updateDhPowerballResult(result) {
    const request = apiHost + "/api/v1/admin/minigame/powerball/result"
    return put(request, result);
}

export function updateDhPowerLadderResult(result) {
    const request = apiHost + "/api/v1/admin/minigame/powerladder/result"
    return put(request, result);
}

export function getCompanyMinigameLevelSetting(params) {
    const request = apiHost + "/api/v1/admin/minigame/level/setting"
    return post(request, params);
}

export function saveCompanyMinigameLevelSetting(params) {
    const request = apiHost + "/api/v1/admin/minigame/level/setting/save"
    return put(request, params);
}



// 베팅 취소
export function cancelBetting(betting) {
    const request = apiHost + "/api/v1/admin/betting/cancel/admin"
    return put(request, betting)
}

/**
 * 종목관리
 */
export function getCompanySportList(params) {
    const companyCode = params.companyCode;

    const request = apiHost + "/api/v1/admin/sports/event/company/"+companyCode+"/separated";
    return get(request)
}

export function setCompanySports(companyCode, sports, userName) {
    const request = apiHost + "/api/v1/admin/sports/event/company/"+companyCode+ "/bulk";
    return put(request, sports, {params: {userName: userName}});
}

/**
 * 리그관리
 */
export function getCompanyLeagueSport(params) {
    const companyCode = params.companyCode;
    const sport = params.sport;

    const request = apiHost + "/api/v1/admin/sports/league/company/"+companyCode+"/sport/"+sport+"/separated";
    return get(request)
}

export function setCompanyLeague(companyCode, leagues, sport, userName) {
    const request = apiHost + "/api/v1/admin/sports/league/company/"+companyCode+ "/" + sport + "/bulk";
    return put(request, leagues, {params: {userName: userName}});
}

/**
 * 쪽지관리
 */
export function sendNote(noteData, headers) {
    const request = "/api/v1/admin/user-notes/send";
    return instance.post(request, noteData, { headers });
}

export function sendBulkNote(noteData, headers) {
    const request = "/api/v1/admin/user-notes/send-bulk";
    return instance.post(request, noteData, { headers });
}

/**
 * 사용자의 쪽지 목록 조회
 */
export function getNoteList(companyCode, userId, page, size) {
    const request = apiHost + "/api/v1/admin/user-notes/list";
    return get(request, {
        companyCode: companyCode,
        userId: userId,
        page: page || 0,
        size: size || 999
    });
}

/**
 * 쪽지 상세 조회
 */
export function getNoteDetail(seq) {
    const request = apiHost + "/api/v1/admin/user-notes/" + seq;
    return get(request);
}

/**
 * 쪽지 삭제 (논리적 삭제)
 */
export function deleteNote(seq, userId) {
    const request = apiHost + "/api/v1/admin/user-notes/" + seq;
    return deleteM(request, { userId: userId });
}

/**
 * 게임 목록
 */
export function getGameList(companyCode, gameDiv) {
    const request = apiHost + "/api/v1/admin/game/" + companyCode + "/" + gameDiv + "/list"
    return get(request)
}

export function getGameListAll(companyCode) {
    const request = apiHost + "/api/v1/admin/game/" + companyCode + "/list"
    return get(request)
}

export function saveGameList(data) {
    const request = apiHost + "/api/v1/admin/game/save"
    return put(request, data)
}

// 강제로그아웃
export function forceSessionLogout(sessionId) {
    const request = apiHost + "/api/v1/admin/user/logout/" + sessionId
    return get(request)
}

// 미니게임 배팅카트 조회
export function getMinigameHoleList(companyCode, minigame) {
    const request = apiHost + "/api/v1/admin/minigame/" + companyCode + "/" + minigame + "/hole/list"
    return get(request)
}

// 미니게임 베팅카트 사용여부 저장
export function saveMinigameHoleList(params) {
    const request = apiHost + "/api/v1/admin/minigame/hole/save"
    return put(request, params)
}

// 미니게임 배당율 저장
export function saveMinigameHoleOddList(params) {
    const request = apiHost + "/api/v1/admin/minigame/hole/odd/save"
    return put(request, params)
}

// 파트너 대상 목록 가져오기
export function getPartnerPossibleUserList(param) {
    const request = apiHost + "/api/v1/admin/partner/possible/list"
    return post(request, param)
}

// 파트너 변경
export function changeUserPartner(param) {
    const request = apiHost + "/api/v1/admin/partner/change"
    return post(request, param)
}

// 베팅조합 차단 목록
export function getBettingBlockList(param) {
    const request = apiHost + "/api/v1/admin/sports/betting/block/list"
    return post(request, param)
}

export function saveBettingBlockList(params) {
    const request = apiHost + "/api/v1/admin/sports/betting/block/save"
    return put(request, params)
}

// 1:1문의 답변 매크로 가져오기
export function getBoardMacro(params) {
    const request = apiHost + "/api/v1/admin/board/macro/list";
    return post(request, params);
}

// 1:1문의 답변 매크로 저장
export function saveBoardMacro(params) {
    const request = apiHost + "/api/v1/admin/board/macro/save";
    return put(request, params);
}

// 1:1문의 답변 매크로 삭제
export function deleteBoardMacro(params) {
    const request = apiHost + "/api/v1/admin/board/macro/delete";
    return put(request, params);
}

export function getMinigameList() {
    const request = apiHost + "/api/v1/admin/minigame/list"
    return get(request)
}

export function saveMinigameList(params) {
    const request = apiHost + "/api/v1/admin/minigame/save"
    return put(request, params);
}

export function saveCompanyGameBonusSetting(params) {
    const request = apiHost + "/api/v1/admin/sports/setting/bonus"
    return put(request, params)
}

export function userCheck(params) {
    const request = apiHost + "/api/v1/admin/user/exists"
    return post(request, params)
}

export function checkNickname(params) {
    const request = apiHost + "/api/v1/admin/user/exists/nickname"
    return post(request, params)
}


export function getMiracleGameResult(params) {
    const request = apiHost + "/api/v1/admin/minigame/miracle/games/result"
    return post(request, params)
}

// 관리자 목록
export function getCompanyAdminList(params) {
    const request  = apiHost + "/api/v1/admin/list";
    return post(request, params);
}

export function putCompanyAdmin(params) {
    const request = apiHost + "/api/v1/admin"
    return post(request, params)
}

export function getBankList(params) {
    const request = apiHost + "/api/v1/main/bank/list"
    return post(request, params)
}

// 출석현황 조회
export function getAttendancePivot(params) {
    const request = apiHost + "/api/v1/admin/attendance/pivot"
    return get(request, params)
}

// 쿠폰 템플릿 관리
export function getCouponTemplateList(params) {
    const request = apiHost + "/api/v1/admin/coupon/templates"
    return get(request, params)
}

export function createCouponTemplate(params) {
    const request = apiHost + "/api/v1/admin/coupon/templates"
    return post(request, params)
}

export function updateCouponTemplate(templateSeq, params) {
    const request = apiHost + "/api/v1/admin/coupon/templates/" + templateSeq
    return put(request, params)
}

// 쿠폰 발행
export function issueCoupon(params) {
    const request = apiHost + "/api/v1/admin/coupon/issue"
    return post(request, params)
}

// 쿠폰 이력 조회
export function getCouponHistory(params) {
    const request = apiHost + "/api/v1/admin/coupon/history"
    return get(request, params)
}

// 통합 잔액 조회
export function getUnifiedBalance(companyCode, userId) {
    const request = apiHost + "/api/v1/casino/balance/unified"
    return get(request, { companyCode, userId })
}

// 통합 트랜스퍼 잔액 출금
/*
Params = {
    companyCode
    userId
    userPw
}
 */
export function unifiedWithdraw(params) {
    const request = apiHost + "/api/v1/casino/withdraw/unified"
    return post(request, params)
}